import {
  DOWNLOAD_XML_ERROR_INVOICES,
  DOWNLOAD_XML_ERROR_INVOICES_FAIL,
  DOWNLOAD_XML_ERROR_INVOICES_SUCCESS,
  ERROR_INVOICES_CREATE,
  ERROR_INVOICES_CREATE_FAIL,
  ERROR_INVOICES_CREATE_RESET,
  ERROR_INVOICES_CREATE_SUCCESS,
  ERROR_INVOICES_DELETE,
  ERROR_INVOICES_DELETE_FAIL,
  ERROR_INVOICES_DELETE_RESET,
  ERROR_INVOICES_DELETE_SUCCESS,
  ERROR_INVOICES_EDIT,
  ERROR_INVOICES_EDIT_FAIL,
  ERROR_INVOICES_EDIT_RESET,
  ERROR_INVOICES_EDIT_SUCCESS,
  ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST,
  ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST_FAIL,
  ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST_RESET,
  ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST_SUCCESS,
  ERROR_INVOICES_RELEASE,
  ERROR_INVOICES_RELEASE_FAIL,
  ERROR_INVOICES_RELEASE_RESET,
  ERROR_INVOICES_RELEASE_SUCCESS,
  ERROR_INVOICES_SEARCH_INVOICE,
  ERROR_INVOICES_SEARCH_INVOICE_FAIL,
  ERROR_INVOICES_SEARCH_INVOICE_RESET,
  ERROR_INVOICES_SEARCH_INVOICE_SUCCESS,
  ERROR_INVOICES_TYPE_INVOICE_LIST,
  ERROR_INVOICES_TYPE_INVOICE_LIST_FAIL,
  ERROR_INVOICES_TYPE_INVOICE_LIST_RESET,
  ERROR_INVOICES_TYPE_INVOICE_LIST_SUCCESS,
  GET_HISTORY_ERROR_ENVOICE_TRANSFER,
  GET_HISTORY_ERROR_ENVOICE_TRANSFER_FAIL,
  GET_HISTORY_ERROR_ENVOICE_TRANSFER_SUCCESS,
  GET_LIST_ERROR_INVOICES,
  GET_LIST_ERROR_INVOICES_FAIL,
  GET_LIST_ERROR_INVOICES_SUCCESS,
  PREVIEW_PDF_ERROR_INVOICE,
  PREVIEW_PDF_ERROR_INVOICE_FAIL,
  PREVIEW_PDF_ERROR_INVOICE_SUCCESS,
  RESET_DOWNLOAD_XML_ERROR_INVOICES,
  RESET_GET_HISTORY_ERROR_ENVOICE_TRANSFER,
  RESET_LIST_ERROR_INVOICES,
  RESET_PREVIEW_PDF_ERROR_INVOICE,
  RESET_TRANSFER_USB_ERROR_INVOICES,
  SET_COLUMN_VISIBLE_ERROR_INVOICES,
  TRANSFER_USB_ERROR_INVOICES,
  TRANSFER_USB_ERROR_INVOICES_FAIL,
  TRANSFER_USB_ERROR_INVOICES_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  type: null,
  // Thông báo hóa đơn sai sót
  notificationErrorInvoices: {
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "-checker_date",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
    loading: false,
    listData: [],
    totalCount: 0,
    columnsVisible: {},
  },
  historyTransferError: {
    data: null,
    loading: true,
    error: null,
  },
  previewPdfErrorFile: {
    data: null,
    loading: true,
    error: null,
  },
  // Download
  fileDownload: null,
  fileDownloadResponse: null,
  fileDownloadName: null,

  // Create Error Invoices
  create: null,
  loadingCreate: false,
  errorCreate: null,
  // Edit Error Invoices
  edit: null,
  loadingEdit: false,
  errorEdit: null,
  // Release
  errorInvoicesRelease: {
    loading: false,
    data: null,
    error: null,
  },
  // Xóa
  errorInvoicesDeleteData: {
    loading: false,
    data: null,
    error: null,
  },
  //
  transferUSB: {
    data: null,
    error: null,
    loading: false,
  },
  // Search Invoice Error Invoices
  searchInvoice: null,
  loadingSearchInvoice: false,
  errorSearchInvoice: null,

  // List Type Invoice Error Invoices
  listTypeInvoice: { items: [] },
  loadingListTypeInvoice: false,
  errorListTypeInvoice: null,

  // List Notification Properties Error Invoices
  listNotificationProperties: { items: [] },
  loadingListNotificationProperties: false,
  errorListNotificationProperties: null,
};

const errorInvoices = (state = INIT_STATE, action) => {
  const curNotificationErrorInvoices = state.notificationErrorInvoices;
  switch (action.type) {
    //GET_HISTORY_TRANSFER
    case GET_HISTORY_ERROR_ENVOICE_TRANSFER:
      return {
        ...state,
        type: action.type,
        historyTransferError: {
          data: null,
          error: null,
          loading: true,
        },
      };
    case GET_HISTORY_ERROR_ENVOICE_TRANSFER_SUCCESS:
      return {
        ...state,
        type: action.type,
        historyTransferError: {
          data: action.data,
          error: null,
          loading: false,
        },
      };

    case GET_HISTORY_ERROR_ENVOICE_TRANSFER_FAIL:
      return {
        ...state,
        type: action.type,
        historyTransferError: {
          data: null,
          error: null,
          loading: false,
        },
      };
    case RESET_GET_HISTORY_ERROR_ENVOICE_TRANSFER:
      return {
        ...state,
        type: action.type,
        historyTransferError: {
          data: null,
          error: null,
          loading: false,
        },
      };

    // PREVIEW_PDF
    case PREVIEW_PDF_ERROR_INVOICE:
      return {
        ...state,
        type: action.type,
        previewPdfErrorFile: {
          data: null,
          loading: true,
          error: null,
        },
      };
    case PREVIEW_PDF_ERROR_INVOICE_SUCCESS:
      return {
        ...state,
        type: action.type,
        previewPdfErrorFile: {
          data: action.data,
          loading: false,
          error: null,
        },
      };
    case PREVIEW_PDF_ERROR_INVOICE_FAIL:
      return {
        ...state,
        type: action.type,
        previewPdfErrorFile: {
          data: null,
          loading: false,
          error: action.error,
        },
      };
    case RESET_PREVIEW_PDF_ERROR_INVOICE:
      return {
        ...state,
        type: action.type,
        previewPdfErrorFile: {
          data: null,
          loading: false,
          error: null,
        },
      };
    // Thông báo hóa đơn sai sót
    case GET_LIST_ERROR_INVOICES:
      return {
        ...state,
        notificationErrorInvoices: {
          ...curNotificationErrorInvoices,
          loading: action.showLoading,
          //   params: action.params,
        },
      };
    case GET_LIST_ERROR_INVOICES_SUCCESS:
      return {
        ...state,
        notificationErrorInvoices: {
          ...curNotificationErrorInvoices,
          loading: false,
          listData: action.listData,
          totalCount: action.totalCount,
        },
      };

    case GET_LIST_ERROR_INVOICES_FAIL:
      return {
        ...state,
        notificationErrorInvoices: {
          ...curNotificationErrorInvoices,
          loading: false,
          listData: [],
          totalCount: 0,
        },
        error: action.error,
      };
    case RESET_LIST_ERROR_INVOICES:
      return {
        ...state,
        notificationErrorInvoices: {
          ...curNotificationErrorInvoices,
          loading: false,
          params: {
            sizePerPage: 10,
            page: 1,
            sort: "-checker_date",
            columnFilter: {},
            keywords: "",
          },
          listData: [],
          totalCount: 0,
        },
        type: action.type,
      };
    // Set column
    case SET_COLUMN_VISIBLE_ERROR_INVOICES:
      curNotificationErrorInvoices.columnsVisible[action.field] = action.value;
      return {
        ...state,
        notificationErrorInvoices: {
          ...curNotificationErrorInvoices,
        },
      };
    // DOWNLOAD_XML_ERROR_INVOICES
    case DOWNLOAD_XML_ERROR_INVOICES:
      return {
        ...state,
        type: action.type,
        fileDownload: null,
        fileDownloadResponse: null,
        fileDownloadName: null,
        error: action.error,
      };
    case DOWNLOAD_XML_ERROR_INVOICES_SUCCESS:
      return {
        ...state,
        type: action.type,
        fileDownload: action.fileDownload,
        fileDownloadResponse: action.fileDownloadResponse,
        fileDownloadName: action.fileDownloadName,
      };
    case DOWNLOAD_XML_ERROR_INVOICES_FAIL:
      return {
        ...state,
        type: action.type,
        fileDownload: null,
        fileDownloadResponse: null,
        fileDownloadName: null,
        error: action.error,
      };
    case RESET_DOWNLOAD_XML_ERROR_INVOICES:
      return {
        ...state,
        type: null,
        error: null,
        // fileDownload: null,
        // fileDownloadResponse: null,
        // fileDownloadName: null,
      };

    // Create Error Invoices
    case ERROR_INVOICES_CREATE:
      return {
        ...state,
        loadingCreate: true,
        errorCreate: null,
      };
    case ERROR_INVOICES_CREATE_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        errorCreate: null,
        create: { ...action.payload, success: true },
      };
    case ERROR_INVOICES_CREATE_FAIL:
      return { ...state, loadingCreate: false, errorCreate: action.payload };
    case ERROR_INVOICES_CREATE_RESET:
      return {
        ...state,
        loadingCreate: false,
        errorCreate: null,
        create: null,
      };
    // EDIT Error Invoices
    case ERROR_INVOICES_EDIT:
      return {
        ...state,
        loadingEdit: true,
        errorEdit: null,
      };
    case ERROR_INVOICES_EDIT_SUCCESS:
      return {
        ...state,
        loadingEdit: false,
        errorEdit: null,
        edit: { ...action.payload, success: true },
      };
    case ERROR_INVOICES_EDIT_FAIL:
      return { ...state, loadingEdit: false, errorEdit: action.payload };
    case ERROR_INVOICES_EDIT_RESET:
      return {
        ...state,
        loadingEdit: false,
        errorEdit: null,
        edit: null,
      };
    //
    case TRANSFER_USB_ERROR_INVOICES:
      return {
        ...state,
        transferUSB: {
          data: null,
          error: null,
          loading: true,
        },
      };
    case TRANSFER_USB_ERROR_INVOICES_SUCCESS:
      return {
        ...state,
        type: action.type,
        transferUSB: {
          data: null,
          error: null,
          loading: false,
        },
      };

    case TRANSFER_USB_ERROR_INVOICES_FAIL:
      return {
        ...state,
        type: action.type,
        transferUSB: {
          data: null,
          error: action.error,
          loading: false,
        },
      };
    case RESET_TRANSFER_USB_ERROR_INVOICES:
      return {
        ...state,
        type: action.type,
        transferUSB: {
          data: null,
          error: null,
          loading: false,
        },
      };

    // Search Invoice Error Invoices
    case ERROR_INVOICES_SEARCH_INVOICE:
      return {
        ...state,
        loadingSearchInvoice: true,
        errorSearchInvoice: null,
      };
    case ERROR_INVOICES_SEARCH_INVOICE_SUCCESS:
      return {
        ...state,
        loadingSearchInvoice: false,
        errorSearchInvoice: null,
        searchInvoice: { data: action.payload || null, success: true },
      };
    case ERROR_INVOICES_SEARCH_INVOICE_FAIL:
      return {
        ...state,
        loadingSearchInvoice: false,
        errorSearchInvoice: action.payload,
      };
    case ERROR_INVOICES_SEARCH_INVOICE_RESET:
      return {
        ...state,
        loadingSearchInvoice: false,
        errorSearchInvoice: null,
        searchInvoice: null,
      };

    // List Type Invoice Error Invoices
    case ERROR_INVOICES_TYPE_INVOICE_LIST:
      return {
        ...state,
        loadingListTypeInvoice: true,
        errorListTypeInvoice: null,
      };
    case ERROR_INVOICES_TYPE_INVOICE_LIST_SUCCESS:
      return {
        ...state,
        loadingListTypeInvoice: false,
        errorListTypeInvoice: null,
        listTypeInvoice: { items: action.payload, success: true },
      };
    case ERROR_INVOICES_TYPE_INVOICE_LIST_FAIL:
      return {
        ...state,
        loadingListTypeInvoice: false,
        errorListTypeInvoice: action.payload,
      };
    case ERROR_INVOICES_TYPE_INVOICE_LIST_RESET:
      return {
        ...state,
        loadingListTypeInvoice: false,
        errorListTypeInvoice: null,
        listTypeInvoice: { items: [] },
      };

    // List Notification Properties Error Invoices
    case ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST:
      return {
        ...state,
        loadingListNotificationProperties: true,
        errorListNotificationProperties: null,
      };
    case ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST_SUCCESS:
      return {
        ...state,
        loadingListNotificationProperties: false,
        errorListNotificationProperties: null,
        listNotificationProperties: { items: action.payload, success: true },
      };
    case ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST_FAIL:
      return {
        ...state,
        loadingListNotificationProperties: false,
        errorListNotificationProperties: action.payload,
      };
    case ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST_RESET:
      return {
        ...state,
        loadingListNotificationProperties: false,
        errorListNotificationProperties: null,
        listNotificationProperties: { items: [] },
      };

    // Gửi duyệt hdss
    case ERROR_INVOICES_RELEASE:
      return {
        ...state,
        errorInvoicesRelease: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case ERROR_INVOICES_RELEASE_SUCCESS:
      return {
        ...state,
        errorInvoicesRelease: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    case ERROR_INVOICES_RELEASE_FAIL:
      return {
        ...state,
        errorInvoicesRelease: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case ERROR_INVOICES_RELEASE_RESET:
      return {
        ...state,
        errorInvoicesRelease: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };

    // Xóa thông báo sai sót
    case ERROR_INVOICES_DELETE:
      return {
        ...state,
        errorInvoicesDeleteData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case ERROR_INVOICES_DELETE_SUCCESS:
      return {
        ...state,
        errorInvoicesDeleteData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    case ERROR_INVOICES_DELETE_FAIL:
      return {
        ...state,
        errorInvoicesDeleteData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case ERROR_INVOICES_DELETE_RESET:
      return {
        ...state,
        errorInvoicesDeleteData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    default:
      return state;
  }
};

export default errorInvoices;
